import theme from './theme';

export const getTheme = (propName, propVariant) => props => {
  if (propVariant) {
    return props.theme[propName][propVariant];
  } else {
    return props.theme[propName];
  }
};

export const getVars = (propName, propVariant) => {
  if (propVariant) {
    return theme[propName][propVariant];
  } else {
    return theme[propName];
  }
};

export const screen = screenSize => {
  return theme['breakpoints'][screenSize];
};



// WEBPACK FOOTER //
// ./src/global/utils.js